var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationRed = function SvgExclamationRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF596D",
    fillRule: "nonzero",
    d: "M14.042 19.875h2.916v2.917h-2.916zm0-11.667h2.916v8.75h-2.916zM15.485.917C7.435.917.917 7.45.917 15.5s6.518 14.583 14.568 14.583c8.065 0 14.598-6.533 14.598-14.583S23.55.917 15.485.917m.015 26.25c-6.446 0-11.667-5.221-11.667-11.667S9.054 3.833 15.5 3.833 27.167 9.054 27.167 15.5 21.946 27.167 15.5 27.167"
  })));
};
export default SvgExclamationRed;